import styled from "styled-components";

import {
  TableHeader,
  TableHeaderSortButton,
  TableItem,
} from "../../components/ui/Table/styles";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  flex: 1;
  padding-right: 16px;
  padding-bottom: 32px;
`;

export const TableViewport = styled.div`
  width: 100%;
  overflow-x: auto;
  padding-bottom: 4px;

  > div {
    min-width: ${(props) => props.$minWidth}px;
  }

  ${TableHeader} {
    ${TableItem} span {
      padding: 7px 8px;
      font-size: 13px;
      line-height: 18px;
      white-space: nowrap;
    }
  }

  ${TableHeaderSortButton} {
    padding: 7px 8px;
    font-size: 13px;
    line-height: 18px;
    white-space: nowrap;
  }
`;
